import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gestiones-header',
  templateUrl: './gestiones-header.component.html',
  styleUrls: ['./gestiones-header.component.scss']
})
export class GestionesHeaderComponent implements OnInit {

  title = '';

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterContentChecked() {
    const path = window.location.pathname;
    
    if(path.includes("0")) {
      localStorage.setItem("iniciaPreca", "");
      localStorage.setItem("moduleTitle", "");
      localStorage.setItem("moduleSubtitle", "");
      localStorage.setItem("codeudor", "");
    } 

    if(path.includes("gestiones")) 
    {
      const iniciaPreca = localStorage.getItem("iniciaPreca");
      const moduleTitle = localStorage.getItem("moduleTitle");
      const moduleSubtitle = localStorage.getItem("moduleSubtitle");
      
      this.title = null;
      if(iniciaPreca == "ok" && moduleTitle != "") {
        const prefix = ["Estado","Privado"].includes(moduleTitle) ? "Segmento " : "";
        const title = `${prefix} ${moduleTitle} ${moduleSubtitle}` ;
        this.title = title
      }
    } 
  }
}
